import { VoiceMeetingEventBus } from 'features/voice-meeting/services';

/**
 * Extracts error message from different error types
 */
export const extractErrorMessage = (error: unknown): string => {
  if (error instanceof Error) {
    return error.message;
  } else if (typeof error === 'string') {
    return error;
  } else if (error && typeof error === 'object') {
    return (error as { message?: string }).message || JSON.stringify(error);
  }
  return String(error);
};

/**
 * Checks if an error message indicates a completed meeting
 */
export const isMeetingEndedError = (errorMessage: string): boolean => {
  const meetingEndedKeywords = [
    'meeting completed',
    'meeting ended',
    'meeting has ended',
  ];

  const lowerCaseMessage = errorMessage.toLowerCase();

  return meetingEndedKeywords.some((keyword) =>
    lowerCaseMessage.includes(keyword)
  );
};

/**
 * Handles voice meeting specific errors
 * @returns true if the error was handled, false otherwise
 */
export const handleVoiceMeetingError = (error: unknown): boolean => {
  const errorMessage = extractErrorMessage(error);

  if (isMeetingEndedError(errorMessage)) {
    // Signal that the voice session has finished/ended
    VoiceMeetingEventBus.resetVoiceSession$.next();
    return true;
  }

  return false;
};
